"use client";

import { Trans } from "@lingui/react/macro";
import { openCookieSettings } from "@/lib/consent";

/** Footer link that reopens the consent banner so consent stays withdrawable. */
export function CookieSettingsLink({ className }: { className?: string }) {
  return (
    <button type="button" onClick={openCookieSettings} className={className}>
      <Trans>Cookie settings</Trans>
    </button>
  );
}
